import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsInsightsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Insights</div>
          <div className="text">
            Insights are pieces of feedback, context, or information associated with ideas. They can
            be created manually or automatically from comments, votes, or other sources.
          </div>
          <div className="text">The Insights API allows you to list insights for your company.</div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
